import {
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import facebookLogo from "../../components/Layout/facebook.png";
import instagramLogo from "../../components/Layout/instagram.png";
import draxLogo from "../../components/Layout/logo2.png";
import naverLogo from "../../components/Layout/naver.png";

function Layout() {

  const location = useLocation()
  const navigate = useNavigate();

  const genCustomerShortCut = () => {
    if (location.pathname === '/customer') {
      return (
        <div className={`progress-wrap my-1 on`}>
          <a href="/customer" style={{"color":"inherit"}}>
            <div className="numbering mx-2 orange-light">1</div>
            <div className="p-0">고객정보</div>
          </a>
        </div>
      )
    } else {
      return (
        <div className={`progress-wrap my-1 on`}>
          <a href="/customer" style={{"color":"inherit"}}>
            <div className="numbering mx-2" >1</div>
            <div className="p-0">고객정보</div>
          </a>
        </div>
      )
    }
  }

  const genModelShortCut = () => {
    if (location.pathname === '/models/') {
      return (
        <div className={`progress-wrap on my-1`}>
          <a href="/models/" style={{"color":"inherit"}}>
            <div className="numbering mx-2 orange-light">2</div>
            <div className="p-0">모델정보</div>
          </a>
        </div>
      )
    } else if (location.pathname === '/customer'){
      return (
        <div className={`progress-wrap off my-1`}>
          <div className="numbering mx-2">2</div>
          <div className="p-0">모델정보</div>
        </div>
      )
    } else {
      return (
        <div className={`progress-wrap on my-1`}>
          <a href="/models/" style={{"color":"inherit"}}>
            <div className="numbering mx-2">2</div>
            <div className="p-0">모델정보</div>
          </a>
        </div>
      )
    }
  }

  const genSymptomShortCut = () => {
    if (location.pathname === '/reservation/') {
      return (
        <a href="/reservation/">
          <div className={`progress-wrap on my-1`}>
            <div className="numbering mx-2 orange-light">3</div>
            <div className="p-0">상세증상</div>
          </div>
        </a>
      )
    } else {
      return (
        <div className={`progress-wrap off my-1`}>
          <div className="numbering mx-2">3</div>
          <div className="p-0">상세증상</div>
        </div>
      )
    }
  }



  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "90%",
          maxWidth: "600px",
        }}
      >
        <h1 className="align-center my-4" style={{cursor:'pointer'}} onClick={() => navigate('/')}>디랙스 서비스센터</h1>
          <div className="ui divider"></div>
          <div className="d-flex justify-content-between mx-5">
              {genCustomerShortCut()}
              {genModelShortCut()}
              {genSymptomShortCut()}
          </div>

          <div className="information card background-grey">
              <div>* 모델명을 잘못 기입할 경우 <span className="emphasis">재방문 및 출장비(44,000원)</span>가 부과될 수 있습니다.</div>
              <div>* 입력하신 정보가 <span className="emphasis">정확하지 않을</span> 경우 또는 <span className="emphasis">타사 제품</span>인 경우 서비스가 <span className="emphasis">취소 또는 지연될 수 있음</span>을 알려드립니다.</div>
              <div>* <span className="emphasis">보증기간이 경과된 제품</span> 또는 보증기간 내라도 <span className="emphasis">고장이 아니거나 사용자 과실</span>인 경우 <span className="emphasis">유상 청구</span>될 수 있습니다.</div>
              <div>* <span className="emphasis">소모품 교체</span> 는 <a href="https://smartstore.naver.com/drax" target="_blank" rel="noreferrer"><span className="emphasis">스마트스토어</span></a>를 통해 간단히 해결할 수 있습니다.<a href="https://smartstore.naver.com/drax" target="_blank" rel="noreferrer">(스마트스토어로 이동하기)</a></div>
          </div>
        <Outlet />
        {/* footer */}
        <div className="ui divider"/>
        <div className="information2 row" style={{ display: "flex" }}>
          <div
            style={{
              width: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: '0',
              paddingTop: '0',
              paddingBottom: '1rem'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
              <div style={{ flex: '0 0 80%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80%' }}>
                <img
                  src={draxLogo}
                  alt="Drax"
                  className="py-1"
                  style={{ width: '100%', height: 'auto', maxWidth: '200px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.draxfit.com/', '_blank')}
                />
              </div>
              <div style={{ flex: '0 0 20%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20%' }}>
                <img
                  src={naverLogo}
                  alt="Naver"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://blog.naver.com/draxfit_official/', '_blank')}
                />
                <img
                  src={instagramLogo}
                  alt="Instagram"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.instagram.com/draxfit_official/', '_blank')}
                />
                <img
                  src={facebookLogo}
                  alt="Facebook"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.facebook.com/DRAXFIT/', '_blank')}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              width: "50%",
              textAlign: 'left',
              fontSize: '0.75rem',
              paddingBottom: '1.5rem',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <div style={{ fontWeight: 'bold', fontSize: '1.5rem', marginBottom: '8px' , marginTop: '27px'}}>주식회사 디랙스</div>
            <div style={{ marginBottom: '0.5px' }}>본사/제1공장 : 경기 안양시 만안구 전파로62번길 26</div>
            <div style={{ marginBottom: '0.5px' }}>제2공장 : 경기 안양시 만안구 전파로 48</div>
            <div style={{ marginBottom: '0.5px' }}>제3공장 : 경기 안양시 만안구 덕천로72번길 85</div>
            <div style={{ marginBottom: '0.5px' }}>사업자등록번호 123-81-70002</div>
            <div style={{ marginBottom: '0.5px' }}>TEL: 031-459-8530 / FAX: 031-459-8531</div>
          </div>
        </div>
        {/* footer */}
        <ToastContainer
            position="top-center"
            autoClose={1000}
      />
      </div>
    </div>
  );
}

export default Layout;
